import { useEffect } from "react";
import { motion } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
};

export const usePageTitle = (title) => {
    useEffect(() => {
        document.title = title;
    }, [title]);
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.7, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Chapter = ({ index, eyebrow, title, dark = false, testId }) => (
    <div data-testid={testId}>
        <div className="flex items-baseline gap-4">
            <span
                className={`font-mono text-sm ${dark ? "text-saffron" : "text-saffron"}`}
                data-testid={testId ? `${testId}-index` : undefined}
            >
                {index}
            </span>
            <span
                className={`text-xs sm:text-sm uppercase tracking-[0.22em] font-medium font-mono ${
                    dark ? "text-mist" : "text-smoke"
                }`}
            >
                {eyebrow}
            </span>
        </div>
        <h2
            className={`mt-4 font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] ${
                dark ? "text-cream" : "text-ink"
            }`}
        >
            {title}
        </h2>
    </div>
);
